// extracted by mini-css-extract-plugin
export default {"layout":"Wc8Bz","content":"zUHAd","warning":"VwwUf","spotify":"fmIOT","trigger":"eMiuf","device":"KnfWp","devices":"w7rch"};